import { LocalizationMixin } from '@/main/mixins/localization';
import { LoggedUserMixin } from '@/main/mixins/loggedUser';
import { ErrorAlertMixin } from '@/main/mixins/errorAlert';

import { TabsOperationMixin } from '../utils/tabsOperations';

export const mixins = {
	mixins: [LocalizationMixin, LoggedUserMixin, ErrorAlertMixin, TabsOperationMixin],
};
